module.exports = __webpack_public_path__ + "static/img/01.3d70cd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhmnq/01.jpg
// module id = 8CE7
// module chunks = 1